export const INFINITY = 'Inf';
export const RESULTS_PER_PAGE = 10;
export const MAX_FILE_SIZE = 1024 ** 2 * 10; // 10 MB
export const MAX_FILE_SIZE_INGEST = 1024 ** 2 * 50; // 50 MB
export const QUOTE_DOCUMENT_PATH = 'quote_documents';
export const SNAP_QUOTE_DOCUMENT_PATH = 'snap_quote_documents';
export const SNAP_OPERATION_DOCUMENT_PATH = 'snap_operation_documents';

// @NOTE(NT): This prefix is presently the only way we can
// distinguish between quotes created in SNAP and quotes created
// in Visual. If this is changed, _all the things_ will break.
export const SNAP_QUOTE_PREFIX = 'QQ';
// (It's QQ because SNAP was originally just quickquote)

export const SNAP_GENERATED_PART_ID_PREFIX = 'snap-';

/**
 * Upper bound on the number of rows that we expect to be affected in Visual
 * by queries.
 */
export const NOMINAL_SEND_QUOTE_AFFECTED_ROWS_LIMIT = 300;
